import React, { FC } from 'react'
import { useController } from 'react-hook-form'
import { MultiSelectCombobox } from '../../../../legacy-design-system/combobox'
import { JiraFormFieldTypes } from './jira-form-field-types'
import { APPLICATION_IMPORTANCE_LIST } from '../../../../ng/components/jenkins-controller/legacy-constants'

export const ApplicationImportance: FC = () => {
  const {
    field: { onChange, value }
  } = useController({ name: JiraFormFieldTypes.APPLICATION_IMPORTANCE })

  const importances = [...APPLICATION_IMPORTANCE_LIST]

  return (
    <MultiSelectCombobox
      values={value}
      label=""
      items={[
        {
          items: importances ?? []
        }
      ]}
      itemToString={(item) => item.name}
      itemToID={(item) => item.name}
      renderLabel={() => undefined}
      onChange={onChange}
      data-testid="importance-multi-select"
    />
  )
}
